import { Icon } from "@deligoo/ui"
import clsx from "clsx"
import { MouseEvent, useRef } from "react"
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify"

import cls from "./Clipboard.module.scss"

const TOAST_OPTIONS = {
  position: "bottom-right",
  toastId: "copyToClipboard",
  updateId: "copyToClipboard",
  autoClose: 2000,
} as const

type ClipboardProps = {
  className?: string
  children: React.ReactNode
}

const Clipboard = ({ className, children }: ClipboardProps) => {
  const textRef = useRef<HTMLDivElement>(null)

  const { t } = useTranslation()

  function copyToClipboard(e: MouseEvent<HTMLDivElement>) {
    e.stopPropagation()

    const text = textRef?.current?.innerText

    if (!text) return

    navigator.clipboard.writeText(text).then(
      () => toast.success(t("clipboard.success"), TOAST_OPTIONS),
      () => toast.error(t("clipboard.fail"), TOAST_OPTIONS)
    )
  }

  return (
    <div title={t("clipboard.copy")} className={cls.clipboard} role="button" onClick={copyToClipboard}>
      <div className={clsx(className)} ref={textRef}>
        {children}
      </div>

      <Icon name="duplicate" className={cls.icon} color="muted" size="small" />
    </div>
  )
}

export { Clipboard }
